module.exports = __webpack_public_path__ + "5490f4843b50e1b9adec88738b9cde4f.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/line-james.png
// module id = 234
// module chunks = 30